import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  active: false,
  timeElapsed: 0,
  lastActivityTimestamp: null,
};

const slice = createSlice({
  name: 'inactivity',
  initialState,
  reducers: {
    start: (state, action) => ({
      ...state,
      active: true,
      lastActivityTimestamp: state.lastActivityTimestamp || (new Date()).valueOf(),
    }),
    newActivity: (state, action) => ({
      ...state,
      lastActivityTimestamp: (new Date()).valueOf(),
    }),
    stop: (state, action) => ({...initialState}),
  },
});

export const { start, stop, newActivity } = slice.actions;

export default slice.reducer;
